import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import Icon from './Icon'

class Modal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      unique: 'modal-' + Math.round(Math.random() * 1000),
      maxHeight: 99999,
      sectionHeight: 99999
    }
  }

  componentDidMount() {
    if (!this.props.scrollable) {
      return
    }

    const root = document.getElementById(this.state.unique)
    if (!root) {
      return
    }

    const styles = window.getComputedStyle(root)
    const containerHeight = window.innerHeight - parseFloat(styles['top']) * 2

    let sectionHeight = containerHeight
    const header = root.querySelector('header')
    if (header) {
      sectionHeight -= header.offsetHeight
    }

    const footer = root.querySelector('footer')
    if (footer) {
      sectionHeight -= footer.offsetHeight
    }

    this.setState({
      maxHeight: containerHeight,
      sectionHeight: sectionHeight
    })
  }

  onCloseCallback() {
    if (typeof this.props.onClose === 'function') {
      return this.props.onClose()
    }
  }

  render() {
    const { visible, hidden } = this.props

    if (!visible) {
      return ''
    }

    return ReactDOM.createPortal(
      <React.Fragment>
        <div
          id={'fade-' + this.state.unique}
          className={`modal-fade ${hidden ? 'hidden' : ''}`}
          onClick={this.onCloseCallback.bind(this)}
        />
        <div
          id={this.state.unique}
          className={`modal ${hidden ? 'hidden' : ''} ${
            this.props.className || ''
          }`}
          style={{ maxHeight: this.state.maxHeight + 'px' }}
        >
          <header>
            <div className="row align-items-center">
              <div className="col-10">{this.props.header}</div>
              <div className="col-2 text-right">
                <button onClick={this.onCloseCallback.bind(this)}>
                  <Icon icon="times" />
                </button>
              </div>
            </div>
          </header>

          <section
            style={{ maxHeight: this.state.sectionHeight }}
            className={this.props.scrollable ? 'with-scroll' : ''}
          >
            {this.props.children}
          </section>

          {this.props.footer && <footer>{this.props.footer}</footer>}
        </div>
      </React.Fragment>,
      document.body
    )
  }
}

Modal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any.isRequired,
  visible: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
  header: PropTypes.any,
  footer: PropTypes.any,
  scrollable: PropTypes.bool
}

export default Modal
